// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__bcb1v","faq2":"Faq_faq2__+cyrX"};